<template>
  <section>
    <div id="topInfo">
      <!--div class="listName">
        <b style="font-size: 25px; font: bold">My {{ this.header }}</b>
        <button class="addChatButton" @click="creatingGroup">
          Create Group
        </button>
      </div-->

      <div class="optionRow" id="groupNav">
        <div
          class="chatOption"
          :class="currentNotif == 'Chats' ? 'selectedChats' : ''"
          @click="toggleNotif('Chats')"
        >
          All
        </div>
        <div
          class="chatOption"
          :class="currentNotif == 'Courses' ? 'selectedChats' : ''"
          @click="toggleNotif('Courses')"
        >
          Courses
        </div>
        <div
          class="chatOption"
          :class="currentNotif == 'Groups' ? 'selectedChats' : ''"
          @click="toggleNotif('Groups')"
        >
          Groups
        </div>
        <div
          class="chatOption"
          :class="currentNotif == 'Friends' ? 'selectedChats' : ''"
          @click="toggleNotif('Friends')"
        >
          Friends
        </div>
        <div
          class="chatBorderLine"
          :class="[
            currentNotif == 'Chats' ? 'allBoderLine' : '',
            currentNotif == 'Courses' ? 'coursesBoderLine' : '',
            currentNotif == 'Groups' ? 'groupsBoderLine' : '',
            currentNotif == 'Friends' ? 'friendsBoderLine' : '',
          ]"
          @click="test()"
        ></div>
      </div>
    </div>

    <div
      class="groupList"
      :class="{ isWindow: isWindows }"
      v-on:scroll="handleScroll"
    >
      <!-- The id=courses used to be a class -->
      <div id="courses">
        <ul class="menu-list" :key="componentKey">
          <template v-if="currentNotif == 'Chats'">
            <li v-for="group in allGroups" :key="group.id">
              <Group :group="group" />
            </li>
            <div v-if="allGroups.length < 1" class="iconContainer">
              <img class="joinIcon" src="@/assets/Icons/JoinChatsIcon.svg" />
              <b style="font-size: 20px; color: black">Join some chats!</b>
              <p style="font-size: 14px;">
                Join course chats, faculty chats, and many others, or create
                your own!
              </p>
              <div class="smallIconContainer">
                <div class="flexCol">
                  <img
                    src="@/assets/Icons/AddChatIcon.svg"
                    class="smallJoinIcon"
                    @click="addChat"
                  />
                  <p style="font-size: 13px">add chat</p>
                </div>
                <div class="flexCol">
                  <img
                    src="@/assets/Icons/CreateChatIcon.svg"
                    class="smallJoinIcon"
                    @click="createChat"
                  />
                  <p style="font-size: 13px">create chat</p>
                </div>
              </div>
            </div>
          </template>
          <template v-if="currentNotif == 'Courses'">
            <li v-for="group in user.courses" :key="group.id + 'i'">
              <Group :group="group" />
            </li>
            <div v-if="user.courses.length < 1" class="iconContainer">
              <img class="joinIcon" src="@/assets/Icons/JoinCoursesIcon.svg" />
              <b style="font-size: 20px; color: black">Join some courses!</b>
              <p style="font-size: 14px;">
                We have course chats for every class you're in!
              </p>
              <div class="smallIconContainer">
                <div class="textButton" @click="addChat">
                  Join Courses
                </div>
              </div>
            </div>
          </template>
          <template v-if="currentNotif == 'Groups'">
            <li v-for="group in user.groups" :key="group.id + 'k'">
              <Group :group="group" />
            </li>
            <div v-if="user.groups.length < 1" class="iconContainer">
              <img class="joinIcon" src="@/assets/Icons/JoinGroupsIcon.svg" />
              <b style="font-size: 20px; color: black">Join some groups!</b>
              <p style="font-size: 14px;">
                Join and create interest, extracurricular, or any other groups
                you want!
              </p>
              <div class="smallIconContainer">
                <div class="flexCol">
                  <img
                    src="@/assets/Icons/AddChatIcon.svg"
                    class="smallJoinIcon"
                    @click="addGroup"
                  />
                  <p style="font-size: 13px">add group</p>
                </div>
                <div class="flexCol">
                  <img
                    src="@/assets/Icons/CreateChatIcon.svg"
                    class="smallJoinIcon"
                    @click="createChat"
                  />
                  <p style="font-size: 13px">create group</p>
                </div>
              </div>
            </div>
          </template>
          <template v-if="currentNotif == 'Friends'">
            <li v-for="group in user.directMessages" :key="group.id + 'j'">
              <Group :group="group" />
            </li>
            <div v-if="user.directMessages.length < 1" class="iconContainer">
              <img class="joinIcon" src="@/assets/Icons/AddFriendsIcon.svg" />
              <b style="font-size: 20px; color: black">Add some friends!</b>
              <p style="font-size: 14px;">
                Find friends using the search bar, discover page, or invite
                them!
              </p>
              <div class="flexRow">
                <div class="flexCol"></div>
              </div>
            </div>
          </template>
        </ul>
      </div>
      <div v-if="isAdding">
        <AddGroup @reset="reset" />
      </div>

      <div v-if="isEditing">
        <RemoveGroup />
      </div>

      <!-- Done Button -->
      <button
        style="margin-top: 2em"
        v-if="isEditing || isAdding"
        @click="reset()"
        class="doneButton"
      >
        Done
      </button>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Group from "./Group.vue";
import AddGroup from "./group/AddGroup.vue";
import RemoveGroup from "./group/RemoveGroup.vue";
import db from "@/db";

export default {
  data: () => ({
    isWindows: false,
    currentNotif: "Chats",
    header: "Chats",
    isAll: true,
    isCourses: false,
    isGroups: false,
    isFriends: false,
    allGroups: [],
    componentKey: 0,
    notificationListener: [],
  }),
  async created() {
    this.user.courses.forEach((course) => this.setIsSelected(course));
    this.user.faculties.forEach((faculty) => this.setIsSelected(faculty));
    this.user.groups.forEach((group) => this.setIsSelected(group));
    this.user.directMessages.forEach((dm) => this.setIsSelected(dm));
    this.setNotifications();
    this.isWindows = this.checkOS();
    this.allGroups = [
      ...this.user.courses,
      ...this.user.faculties,
      ...this.user.groups,
      ...this.user.directMessages,
    ];
    this.allGroups.sort((a, b) => b.timeOfLastPost - a.timeOfLastPost);
    this.user.courses.sort((a, b) => b.timeOfLastPost - a.timeOfLastPost);
    this.user.faculties.sort((a, b) => b.timeOfLastPost - a.timeOfLastPost);
    this.user.groups.sort((a, b) => b.timeOfLastPost - a.timeOfLastPost);
    this.user.directMessages.sort(
      (a, b) => b.timeOfLastPost - a.timeOfLastPost
    );
    if (this.allGroups.length > 0 && !this.groupId) {
      if (this.allGroups[0].timeOfLastPost) {
        this.componentKey += 1;
      }
      this.$store.commit("messageBoard/setCurGroup", this.allGroups[0]);
      this.$store.commit("messageBoard/setGroupId", this.allGroups[0].id);
      this.$store.commit("messageBoard/setGroupName", this.allGroups[0].name);
      this.$store.commit("messageBoard/setGroupType", this.allGroups[0].type);
    }
  },
  beforeUpdate() {
    this.user.courses.sort((a, b) => b.timeOfLastPost - a.timeOfLastPost);
    this.user.faculties.sort((a, b) => b.timeOfLastPost - a.timeOfLastPost);
    this.user.groups.sort((a, b) => b.timeOfLastPost - a.timeOfLastPost);
    this.user.directMessages.sort(
      (a, b) => b.timeOfLastPost - a.timeOfLastPost
    );
    this.allGroups.sort((a, b) => b.timeOfLastPost - a.timeOfLastPost);
    this.user.courses.forEach((course) => this.setIsSelected(course));
    this.user.faculties.forEach((faculty) => this.setIsSelected(faculty));
    this.user.groups.forEach((group) => this.setIsSelected(group));
    this.user.directMessages.forEach((dm) => this.setIsSelected(dm));
    this.$store.commit("user/setUser", this.user);
  },
  destroyed() {
    this.notificationListener.forEach((listener) => listener());
    this.notificationListener = [];
  },
  components: { Group, AddGroup, RemoveGroup },

  computed: {
    ...mapState("user", ["user"]),
    ...mapState("groups", [
      "isAdding",
      "isEditing",
      "groupType",
      "updateAllGroups",
    ]),
    ...mapState("messageBoard", [
      "searchingGroup",
      "groupId",
      "newNotification",
    ]),
  },

  watch: {
    searchingGroup() {
      this.allGroups = [
        ...this.user.courses,
        ...this.user.faculties,
        ...this.user.groups,
        ...this.user.directMessages,
      ];
      this.allGroups.sort((a, b) => b.timeOfLastPost - a.timeOfLastPost);
    },
    groupId() {
      this.allGroups = [
        ...this.user.courses,
        ...this.user.faculties,
        ...this.user.groups,
        ...this.user.directMessages,
      ];
      this.componentKey += 1;
    },
  },

  methods: {
    ...mapActions("groups", ["setGroupNotificationInfo", "getTimeSincePost"]),
    ...mapActions("user", ["updateUserGroups"]),
    ...mapActions("groupInfo", [
      "getGroupType",
      "getGroupsFromType",
      "getGroupName",
    ]),
    setNotifications() {
      var allGroups = [
        ...this.user.course_ids,
        ...this.user.faculty_ids,
        ...this.user.group_ids,
        ...this.user.dm_ids,
      ];
      var totalGroups = allGroups;
      while (allGroups.length) {
        totalGroups = allGroups.splice(0, 10);
        let listener = db
          .collection("posts")
          .where("chat_id", "in", totalGroups)
          .where("created_at", ">", Date.now())
          .orderBy("created_at", "desc")
          .limit(1)
          .onSnapshot((docs) => {
            docs.forEach(async (doc) => {
              var post = doc.data();
              this.allGroups.forEach(async (group) => {
                if (group.id === post.chat_id) {
                  let index = this.user[group.type].findIndex(
                    (group) => group.id === post.chat_id
                  );
                  await this.setGroupNotificationInfo({
                    group: this.user[group.type][index],
                    notification: post,
                  });
                  this.allGroups = [
                    ...this.user.courses,
                    ...this.user.faculties,
                    ...this.user.groups,
                    ...this.user.directMessages,
                  ];
                  this.$store.commit("user/setUser", this.user);
                }
              });
              this.componentKey += 1;
            });
          });
        this.notificationListener.push(listener);
      }
    },
    setPostContent(group, post) {
      if (post.content == "") {
        let attach = post.files.length == 1 ? "Attachment" : "Attachments";
        group.recentContent = post.files.length + " " + attach;
      } else {
        group.recentContent = post.content;
      }
    },
    reset() {
      this.feedback = "";
      this.alreadyAddedMessage = "";

      this.$store.commit("groups/setIsGroup", false);
      this.$store.commit("groups/setIsCourse", false);
      this.$store.commit("groups/setIsFaculty", false);

      this.$store.commit("groups/setIsAdding", false);
      this.$store.commit("groups/setIsEditing", false);
      this.$store.commit("groups/setIsCreating", false);

      this.$store.commit("groups/setIsShowingGroupTypes", false);
      this.$store.commit("groups/setIsShowingSubjects", false);
    },
    addChat() {
      this.$router.push({ name: "AddCourse" });
    },
    createChat() {
      this.$store.commit("messageBoard/setCreateGroup", true);
    },
    addGroup() {
      this.$router.push({ name: "Discover" });
    },
    checkOS() {
      if (navigator.appVersion.indexOf("Win") != -1) {
        return true;
      }
      return false;
    },
    setIsSelected(group) {
      let groupId = group.id;
      if (groupId === this.groupId) {
        group.isSelected = true;
        this.$store.commit("messageBoard/setCurGroup", group);
        group.hasUnreadPosts = false;
      } else {
        group.isSelected = false;
      }
    },
    isElemVisible(el) {
      var rect = el.getBoundingClientRect();
      var elemTop = rect.top + 100; // 200 = buffer
      var elemBottom = rect.bottom;
      return elemTop < window.innerHeight && elemBottom >= 0;
    },
    handleScroll() {},
    toggleNotif(current) {
      this.allGroups = [];
      this.currentNotif = current;
      this.header = current;
      this.allGroups = this.allGroups.concat(
        this.user.courses,
        this.user.faculties,
        this.user.groups,
        this.user.directMessages
      );
      this.user.courses.sort((a, b) => b.timeOfLastPost - a.timeOfLastPost);
      this.user.faculties.sort((a, b) => b.timeOfLastPost - a.timeOfLastPost);
      this.user.groups.sort((a, b) => b.timeOfLastPost - a.timeOfLastPost);
      this.user.directMessages.sort(
        (a, b) => b.timeOfLastPost - a.timeOfLastPost
      );
      this.allGroups.sort((a, b) => b.timeOfLastPost - a.timeOfLastPost);

      if (current == "Chats") {
        this.isAll = true;
        this.isCourses = false;
        this.isGroups = false;
        this.isFriends = false;
      } else if (current == "Courses") {
        this.isAll = false;
        this.isCourses = true;
        this.isGroups = false;
        this.isFriends = false;
      } else if (current == "Groups") {
        this.isAll = false;
        this.isCourses = false;
        this.isGroups = true;
        this.isFriends = false;
      } else if (current == "Friends") {
        this.isAll = false;
        this.isCourses = false;
        this.isGroups = false;
        this.isFriends = true;
      }
    },
    async updateGroupIfNotified(group) {
      let groupId = group.id;
      if (groupId === this.newNotification[0].id) {
        this.setGroupNotificationInfo({
          group: group,
          notification: this.newNotification[0],
        });
        if (this.isUnread(group)) {
          this.updateNotificationGroups(group);
        }
      }
    },
    isUnread(group) {
      return group.lastVisited < this.newNotification[0].created_at;
    },

    updateNotificationGroups(group) {
      var notifGroups = this.notificationGroups;
      const index = notifGroups.indexOf(group);
      if (index > -1) {
        this.notifGroups.splice(index, 1);
      }
      if (notifGroups.length == 0) {
        this.unbindPosts();
      } else {
        this.newestNotification(notifGroups);
      }
    },
    updateDocumentTitle() {
      if (document.ishidden) {
        document.title = "(1) CourseLnk";
      }
    },
  },
};
</script>

<style src="@/styles/views/Groups.css"></style>
